<div class="user-min-height container-fluid">
    <app-page-header header="{{pageTitle}}" description="{{pageSubTitle}}">
    </app-page-header>

    <!-- Tabs inside col-md-6 -->
    <div class="full-width col-md-12 col-sm-12 col-xs-12 mt-2">
        <div class="app-list">
            <mat-tab-group #tabGroup (selectedIndexChange)="onTabChange($event)">
                <mat-tab label="Users">
                </mat-tab>
                <mat-tab label="Roles">
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>

    <!-- Roles Management Section (Displayed only when Roles tab is selected) -->
    <div class="full-width col-md-12 mt-2" *ngIf="selectedTabIndex === 1">
        <app-roles-management-main></app-roles-management-main>
    </div>
    <div class="full-width col-md-12 mt-2" *ngIf="selectedTabIndex === 0">
        <app-user-management-main></app-user-management-main>
    </div>
</div>
